// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

const  typeDoc  = require('utilities/typeDocument');

// @utils
const { formatText } = require('core/i18n').i18n;
const get = require('lodash/object/get');
import { withRouter } from 'react-router-dom';

// @ commons
const { ModalCustom } = require('commonsComponents/modalCustom');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { FormattedText } = require('core/i18n').i18n;

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');


require('./KeysSendView.scss');
const KeysCCStep1 = require('./KeysCCStep1/KeysCCStep1');
const KeysCCStep2 = require('./KeysCCStep2/KeysCCStep2');
const KeysCCStep3 = require('./KeysCCStep3/KeysCCStep3');

const {
    FIRST_STEP
} = require('constants/index');

class KeysSendView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            resetCounter: 0
        };

        this.handleRequestCodeClick = this.handleRequestCodeClick.bind(this);
        this.handleToogleShowModal = this.handleToogleShowModal.bind(this);
        this.handleGoBack = this.handleGoBack.bind(this);
        this.onHandleResetView  = this.onHandleResetView.bind(this);
        this.onHandleResetStore = this.onHandleResetStore.bind(this);
    }

    componentWillMount() {
        this.onHandleResetStore();
        this.getPhoneOTP();
    }

    componentWillReceiveProps(nextProps){
        const hasError = !!nextProps.immCodeOTPData.get('error');
        if(this.state.showModal != hasError){
            this.setState({showModal:hasError});
        }
    }

    getPhoneOTP(){
        const {immCustomerFinder} =  this.props;
        const immSteps = immCustomerFinder.get('steps');
        const immClientIdentification = immSteps.getIn([ FIRST_STEP , 'response' ]);
        const clientData = immClientIdentification.toJS();
        const documentType = get(clientData, 'documento.documento.tipodocumpersonacorp', '');
        const documentNumber = get(clientData, 'documento.documento.codigodocumpersonacorp', '');

        if(!!documentType && !!documentNumber){
               this.props.requestPhoneOTP(documentType.trim() , documentNumber.trim());
        }else{
             this.props.history.push('/disasterRecovery/customerFinder');
        }
    }

    buildCustomMessageBoxSuccess(){
        const title = formatText('profileKeysLanding-titleMessageBoxSuccess');
        const extraContent = <BlockInfo>{formatText('profileKeysLanding-extraContentMessageBox')}</BlockInfo>
        return (
            <CustomMessageBox
                icon="icon-success"
                title={title}
                extraContent={extraContent}
            />
        )
    }

    buildCustomMessageBoxFailure(){
        const title = formatText('profileKeysLanding-titleMessageBoxFailure');
        const subtitle = formatText('profileKeysLanding-subtitleMessageBoxFailure');
        const textLink = formatText('profileKeysLanding-textLinkMessageBoxFailure').toUpperCase();
        const goBackHandler=this.handleGoBack;

        return (
            <CustomMessageBox
                icon="icon-warning"
                title={title}
                subtitle={subtitle}
                textLink={textLink}
                goBackHandler={goBackHandler}
            />
        )
    }

    handleToogleShowModal(){
        this.setState({
            showModal: !this.state.showModal
        })
    }

    handleRequestCodeClick(){
        this.props.requestcodeOTP();
    }

    handleGoBack(){
        this.props.history.push('/disasterRecovery/customerFinder');
    }

    onHandleResetStore(){
        const {requestClientLoginReset, requestcodeOTPReset, requestSendKeyReset, requestUserDataReset} = this.props;
        requestClientLoginReset();
        requestcodeOTPReset();
        requestSendKeyReset();
        requestUserDataReset();
    }

    onHandleResetView(){
        this.setState({resetCounter: this.state.resetCounter + 1});
        this.onHandleResetStore();
        this.getPhoneOTP();
    }

    buildEndInteractionBlock(){
        const textEndInteraction = formatText('customerFinder-endInteractionText');
        return (
            <div className="keyscc-view__end-interaction-block">
                <div className="keyscc-view__end-interaction-button-container">
                    <div className="keyscc-view__end-interaction-button">
                        <OKButton modifier="link-complementary" size="small" onClick={this.handleGoBack} >
                            <span className="keyscc-view__end-interaction-link">{textEndInteraction}</span>
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }

    handleContent(){
        const {immProfileFields, immUserData, immCodeOTPData, immKeysData, requestSendKey , immCustomerFinder , handleRequestLogin , immLoginAsClient } = this.props;

        const immSteps = immCustomerFinder.get('steps');
        const immClientIdentification = immSteps.getIn([ FIRST_STEP , 'response' ]);
        const clientData = immClientIdentification.toJS();
        const documentType = get(clientData, 'documento.documento.tipodocumpersonacorp', '');
        const documentNumber = get(clientData, 'documento.documento.codigodocumpersonacorp', '');
        const nameCustomer =  get(clientData, 'documento.nombre');

        const typeDocument =  typeDoc.getLabel(documentType.trim());
        const typeDocSpecific = typeDocument.label;
        const isFetchingUserData = immUserData.get('isFetching');
        const phoneUser = immUserData.get('data').get('movil');
        const currentStep =   immUserData.get('step');
        const isFetchingCodeOTP = immCodeOTPData.get('isFetching');
        const isFetchingSendKey = immKeysData.get('isFetching');
        const errorSendKey = immKeysData.get('error');
        const hasBeenSentOTP = immCodeOTPData.get('hasBeenSent');
        const hasBeenSentKey = immKeysData.get('hasBeenSent');
        const recoveryKeyError = immKeysData.get('feedback');
        const onHandlerSendCode = this.handleRequestCodeClick;
        const messageBoxFail = this.buildCustomMessageBoxFailure();
        const titleStep1 = formatText('recoveryKeysDisaster-titleStepOne');
        const titleStep2 = formatText('recoveryKeysDisaster-titleStepTwo');
        const titleStep3 = formatText('recoveryKeysDisaster-titleStepThree');
        const endIntreaction = this.buildEndInteractionBlock();
        const errorState = immLoginAsClient.get('error');
        const isFetchingLoginAsClient = immLoginAsClient.get('isFetching');
        const passwordErrorType = immLoginAsClient.getIn([ 'passwordError', 'errorType' ]);
        const legatText = formatText('recoveryKeysDisaster-legalText');
        let content;

        if(isFetchingUserData){
              content = (<LoadingSection/>);
        }else if( errorState || (hasBeenSentOTP && !hasBeenSentKey && errorSendKey != '' )){
              content = messageBoxFail;
        }else{
            content = (
                <div className="keyscc-view__content-step">
                    <p className="keyscc-view__legal">
                        {legatText}
                    </p>
                    <h3 className="keyscc-view__section-title">
                        <FormattedText value="recoveryKeysDisaster-title" />
                    </h3>
                    <KeysCCStep1
                        documentNumer={documentNumber}
                        documentType={typeDocSpecific}
                        mobileNumber={phoneUser}
                        requestCodeOTP={onHandlerSendCode}
                        isFetching={isFetchingCodeOTP}
                        hasBeenSent={hasBeenSentOTP}
                        titleStep={titleStep1}
                        isFetchingUserData={isFetchingUserData}
                        currentStep={currentStep}
                        isDisaster={true}
                    />
                    <KeysCCStep2
                        isFetching={isFetchingSendKey}
                        isFetchingOTP={isFetchingCodeOTP}
                        requestKey={requestSendKey}
                        requestCodeOTP={onHandlerSendCode}
                        hasBeenSent={hasBeenSentOTP}
                        hasError={errorSendKey}
                        immProfileFields={immProfileFields}
                        titleStep={titleStep2}
                        inlineErrorMessage={recoveryKeyError}
                        currentStep={currentStep}
                        isDisaster={true}
                        resetCounter={this.state.resetCounter}
                    />
                    <KeysCCStep3
                        nameCustomer={nameCustomer}
                        titleStep={titleStep3}
                        documentNumber={documentNumber}
                        documentType={typeDocSpecific}
                        documentTypeCode={documentType}
                        currentStep={currentStep}
                        passwordErrorType={passwordErrorType}
                        handleRequestLogin={handleRequestLogin}
                        handleResetView={this.onHandleResetView}
                        isFetchingLogin={isFetchingLoginAsClient}
                        error={errorState}
                        resetCounter={this.state.resetCounter}
                    />
                    {endIntreaction}
                </div>);
        }
        return content;
    }

    buildErrorSendCodeModal(){
        const {immCodeOTPData} = this.props;
        const isFetchingCodeOTP = immCodeOTPData.get('isFetching');
        const modalHeader= formatText('profileKeysLanding-modalHeader');
        const modalButtonText = formatText('profileKeysLanding-modalButtonText');
        const errorCode = immCodeOTPData.getIn(['error', 'description', 0, 'codigo']);
        let modalBody = '';

        switch (errorCode) {
            // description Codigo OTP Vigente
            case '410071':
                modalBody = formatText('profileKeysLanding-modalBodyOTPCodeValid');
                break;
            // description OTP_NUM_VECES_OTP_GENERADO_SUPERADO
            case '410072':
                modalBody = formatText('profileKeysLanding-modalBodyExceededOTPGenerations');
                break;
            default:
                modalBody = formatText('profileKeysLanding-modalBody');
                break;
        }

        return (
            <ModalCustom
                shouldCloseOnOverlayClick={false}
                isOpen={this.state.showModal}
                extraClass="keyscc-view__modal"
                onRequestClose={this.handleToogleShowModal}
            >
                <header className="keyscc-view__modal-header">
                    {modalHeader}
                </header>
                <section className="keyscc-view__section">
                    <p className="keyscc-view__modal-message">
                        <span className="keyscc-view__modal-icon">
                            <i className="icon-error"/>
                        </span>
                        <span className="keyscc-view__modal-body">
                            {modalBody}
                        </span>
                    </p>
                </section>
                <footer className="keyscc-view__modal-footer">
                    <div className="pull-right">
                        <OKButton
                            modifier="primary"
                            loading={isFetchingCodeOTP}
                            onClick={this.handleRequestCodeClick} // eslint-disable-line
                        >
                            {modalButtonText}
                        </OKButton>
                    </div>
                </footer>
            </ModalCustom>
        )
    }

    render() {
        const titleHeader = formatText('profileKeysLanding-title');
        const modal = this.buildErrorSendCodeModal();
        const content = this.handleContent();
        const mappingBreadcrumb = [
            ...(!__CONTACT_CENTER__ ? [
                {
                    text: titleHeader,
                    url: '/myprofile/keys'
                }
            ] : []),
            {
                text: formatText('profileKeysLanding-requestNewKey')
            }
        ]

        return (
            <div className="keyscc-view">
                <OKHeaderCC
                    title={titleHeader}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={false}
                />
                <div className="keyscc-view__body">
                    {content}
                </div>
                {modal}
            </div>
        );
    }
}

KeysSendView.propTypes = {
    history: PropTypes.object.isRequired,
    immCustomerFinder: PropTypes.object.isRequired,
    immUserData: PropTypes.object,
    immCodeOTPData : PropTypes.object,
    immKeysData : PropTypes.object,
    immProfileFields: PropTypes.object,
    immLoginAsClient: PropTypes.object,
    requestcodeOTP: PropTypes.func,
    requestSendKey : PropTypes.func,
    requestPhoneOTP: PropTypes.func,
    requestcodeOTPReset : PropTypes.func,
    requestSendKeyReset: PropTypes.func,
    handleRequestLogin : PropTypes.func,
    requestClientLoginReset : PropTypes.func,
    requestUserDataReset : PropTypes.func,
};

module.exports = withRouter(KeysSendView);
